<template>
  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">课程列表</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新增课程</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button @click="backList" type="primary">返回课程列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item label="课程标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入课程标题"></el-input>
          </el-form-item>



          <el-form-item label="课程分类" prop="info_type">
            <el-select v-model="form.info_type" placeholder="请选择课程分类">
              <!-- <el-option label="图文" value="1"></el-option>
              <el-option label="音频" value="2"></el-option>
              <el-option label="视频" value="3"></el-option>
              <el-option label="打卡文章" value="4"></el-option>
              <el-option label="帮助文档" value="5"></el-option> -->
              <el-option
                v-for="option in outTOptions"
                :value="option.id"
                :key="option.id"
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程类型" prop="info_type_tt">
            <el-select v-model="form.info_type_tt" :disabled='form.id != null' placeholder="请选择课程类型">
              <el-option label="图文" value="1"></el-option>
              <el-option label="音频" value="2"></el-option>
              <el-option label="视频" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="价值观" prop="work_type" v-if="form.info_type == 4">
            <el-select v-model="form.work_type" placeholder="请选择价值观">
              <el-option label="知感恩" value="知感恩"></el-option>
              <el-option label="讲诚信" value="讲诚信"></el-option>
              <el-option label="重结果" value="重结果"></el-option>
              <el-option label="喜变化" value="喜变化"></el-option>
              <el-option label="负责任" value="负责任"></el-option>
              <el-option label="懂原则" value="懂原则"></el-option>
              <el-option label="乐付出" value="乐付出"></el-option>
              <el-option label="做好人" value="做好人"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程标签" prop="type_id" v-if="form.info_type != 4 && form.info_type != 5">
            <el-select v-model="form.type_id">
              <el-option
                v-for="option in typeOptions"
                :value="option.id"
                :key="option.id"
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="列表图片" prop="list_pic" v-if="form.info_type != 5">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.list_pic" :src="form.list_pic" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item v-if="form.info_type_tt == 1" label="文章图片" prop="main_pic">
            <el-upload
              class="upload-demo"
              :multiple="true"
              action="/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess1"
              :on-remove="handleRemove"
              :data="tokenData"
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：375px × 375px</div>
            </el-upload>
          </el-form-item>

          <el-form-item v-if="form.info_type_tt == 2" label="音频" prop="list_pic">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData1"
              :on-success="handleAvatarSuccessMp3"
              :before-upload="beforeAvatarUpload"
            >
              <audio controls v-if="form.mp3Path">
                <source :src="form.mp3Path" type="audio/ogg">
                您的浏览器不支持 audio 元素。
              </audio>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传mp3格式的文件</div>
            </el-upload>
          </el-form-item>

          <el-form-item v-if="form.info_type_tt == 3" label="视频" prop="videoPath">
            <!-- <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData1"
              :on-success="handleAvatarSuccessMp4"
              :before-upload="beforeAvatarUpload"
            >
              <video v-if="form.videoPath" width="320" height="240" controls="controls">
                <source :src="form.videoPath" type="video/mp4" />
              </video>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传mp4格式的文件</div>
            </el-upload> -->
            <template>
              <div>
                  <input type="file" name='upFile' id="upFile" @change='changeFile($event)'>
                  <input type="button" name="开始上传" value="开始上传" @click='uploadFile()'>
                  <video  autoplay controls height="400" v-if="form.videoPath" :src="form.videoPath" alt="预览"></video>
                  <el-progress :percentage="filePercent"></el-progress>
              </div>
            </template>
          </el-form-item>

          <el-form-item v-if="form.info_type_tt == 3" label="视频封面" prop="videoImg">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccessVideo"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.videoImg" :src="form.videoImg.url" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item v-show="form.info_type != 4 && form.info_type != 5" label="文本描述" prop="content">
            <el-input :rows="20" v-model="form.content" type="textarea"></el-input>
          </el-form-item>

          <el-form-item v-show="form.info_type == 4 || form.info_type == 5">
            <UEditor
              :config=config
              ref="ueditor"
            ></UEditor>
          </el-form-item>

          <el-form-item>
            <el-button v-if="hasPower('20051991')" type="primary" @click="onSubmit('form')" :loading="addLoading">{{wordName}}</el-button>
            <el-button @click="resetForm1">重置</el-button>
            <el-button @click="backList">返回列表</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { pca, pcaa } from "area-data";
import UEditor from "@/components/ueditor.vue";
import { dateFunc } from "../../dateFunc.js";
import * as qiniu from "qiniu-js";

var _ = require("lodash");
export default {
  name: "add_good",
  components: { UEditor },
  data() {
    return {
      file:null,
      videoUrl:null,
      coverUrl:null,
      filePercent:0,
      token: null,
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/static/ueditor/"
      },
      typeOptions: [],
      outTOptions:[],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      tokenData1: {
        token: localStorage.getItem("api_token"),
        video:1
      },
      options: [],
      good: null,
      wordName: "新增",
      props: {
        value: "id",
        label: "type_name"
      },
      addFormRule: {
        title: [
          {
            required: true,
            message: "请输入课程标题",
            trigger: "blur"
          }
        ],
        info_type: [
          {
            required: true,
            message: "请选择课程分类",
            trigger: "blur"
          }
        ]
      },
      addLoading: false,
      fileList2: [],
      fileList4:[],
      form: {
        title: null,
        info_type_tt:'1',
        info_type: null,
        type_id: null,
        content: null,
        work_type:null,
        list_pic: null,
        videoPath: null,
        mp3Path: null,
        imgPath: null,
        fileList2: [],
        videoImg: null,
        id: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    let that = this
    this.getOnToken();
    this.page_num = 1;
    let params = {
      pageNum: 1,
      pageSize: 100,
      infoType: 3,
      token: localStorage.getItem("api_token")
    };
    let params1 = {
      pageNum: 1,
      pageSize: 100,
      infoType: 8,
      noVip:1,
      token: localStorage.getItem("api_token")
    };
    that.loading = true;
    API.good_first_type_list(params1)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.outTOptions = [];
            for (var i = 0; i < result.result.list.length; i++) {
              if (result.result.list[i].title != "全部") {
                that.outTOptions.push(result.result.list[i]);
              }

            }
            that.outTOptions.push({
                id:4,
                title:'打卡文章'
              });
              that.outTOptions.push({
                id:5,
                title:'帮助文档'
              });
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    API.good_first_type_list(params)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.typeOptions = [];
            for (var i = 0; i < result.result.list.length; i++) {
              if (result.result.list[i].title != "全部") {
                that.typeOptions.push(result.result.list[i]);
              }
            }
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var good = this.$route.query.good;
    this.good = good;
    var para = {
      id: this.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      console.info(good);
      that.wordName = "修改";
      that.form.id = good.id;
      that.form.type_id = good.type_id;
      this.form.title = good.title;
      that.form.info_type = good.info_type
      that.form.list_pic = good.list_pic;
      that.form.work_type = good.work_type;
      that.form.videoPath = good.video_path;
      that.form.mp3Path = good.mp3_path;
      if (good.info_type == 4 || good.info_type == 5)
      {
        that.$refs.ueditor.setContentInfo(good.content);
      } else {
        that.form.content = good.content;
      }
      if (that.form.mp3Path && that.form.mp3Path != null)
      {
        that.form.info_type_tt = '2';
      } else if (that.form.videoPath && that.form.videoPath != null)
      {
        that.form.info_type_tt = '3';
      } else
      {
        that.form.info_type_tt = '1';
      }
      if (that.form.info_type_tt == 1) {
        var url1 = JSON.parse(good.image_path);
        for (var i = 0; i < url1.length; i++) {
          that.fileList4.push({
            name: url1[i].name,
            url: url1[i].url,
            uid: url1[i].uid,
            height: url1[i].height,
            width: url1[i].width
          });
          that.form.fileList2.push({
            name: url1[i].name,
            url: url1[i].url,
            uid: url1[i].uid,
            height: url1[i].height,
            width: url1[i].width
          });
        }
        that.fileList2 = that.form.fileList2;
      }
    } else {
      that.form.status = "1";
      that.wordName = "立即创建";
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    onEditorReady(editor) {},
    backList() {
      this.$router.push({
        path: "/courseList"
      });
    },
    handleChange() {},
    handleRemove(file, fileList) {
      var list = [];
      for (var i = 0; i < this.fileList4.length; i++) {
        if (this.fileList4[i].uid && this.fileList4[i].uid != null) {
          if (this.fileList4[i].uid != file.uid) {
            list.push(this.fileList4[i]);
          }
        } else {
          if (this.fileList4[i].name != file.name) {
            list.push(this.fileList4[i]);
          }
        }
      }
      this.fileList4 = list;
      if (this.fileList4.length == 0) {
        this.form.main_pic = null;
      } else {
        this.form.main_pic = JSON.stringify(this.fileList4);
      }
    },
    handlePreview(file) {},
    handleAvatarSuccess1: function(e, file) {
      if (e.key == 1000) {
        this.fileList4.push({
          name: file.name,
          uid: file.uid,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });
        this.form.main_pic = this.fileList4;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("main_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.list_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessVideo: function(e, file) {
      if (e.key == 1000) {
        this.form.videoImg = {
          name: file.name,
          uid: file.uid,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        };
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("main_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessMp3: function(e) {
      if (e.key == 1000) {
        this.form.mp3Path = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessMp4: function(e) {
      if (e.key == 1000) {
        this.form.videoPath = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    beforeAvatarUpload: function(e) {},
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    getOnToken(){
      var that = this;
      let pa ={
        token: localStorage.getItem("api_token")
      }
      API.seven_token(pa)
      .then(function(result){
          console.log(result)
          if (result.key == 1000) {
            that.token=result.message
          }
      },
      function(err) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: err.toString(),
          duration: 2000
        });
      }).catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    },
    changeFile(e){
      this.file = e.target.files[0];
    },

    async uploadFile() {
      let that = this
      var config = {
        useCdnDomain: true,
        chunkSize: 100,     //每个分片的大小，单位mb，默认值3
        forceDirect: true    //直传还是断点续传方式，true为直传
      };
      var putExtra = {
        fname: that.file.name,
        params: {},
        mimeType: [] || null
      };
      var observable = qiniu.upload(that.file,that.file.name + new Date().getTime(),that.token,putExtra,config);
      var observer = {
        next(res) {
            that.filePercent = parseInt(res.total.percent)
        },
        error(err) {
          console.log(err)
          that.$message.error({
                showClose: true,
                message: "上传失败,请稍后再试",
                duration: 2000
              });
        },
        complete(res) {
              that.form.videoPath = "https://vedio.hkymr.com/" + res.key
              that.$message.success({
                showClose: true,
                message: "上传成功",
                duration: 1500
              });
            }
        }
      var subscription = observable.subscribe(observer); // 上传开始
    },
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          if (para.info_type == 1) {
            if (that.fileList4.length == 0) {
              that.$message.error({
                showClose: true,
                message: "请上传图片",
                duration: 2000
              });
              return;
            } else {
              para.imgPath = JSON.stringify(that.fileList4);
            }
          } else if (para.info_type == 2) {
            if (para.mp3Path == null || para.mp3Path == '') {
              that.$message.error({
                showClose: true,
                message: "请上传音频",
                duration: 2000
              });
              return;
            }
          } else if (para.info_type == 3) {
            if (para.videoPath == null || para.videoPath == '') {
              that.$message.error({
                showClose: true,
                message: "请上传视频",
                duration: 2000
              });
              return;
            }
            if (para.videoImg == null || para.videoImg == '') {
              that.$message.error({
                showClose: true,
                message: "请上传视频封面",
                duration: 2000
              });
              return;
            } else {
              para.imgPath = JSON.stringify(para.videoImg);
            }
          } else if (para.info_type == 4) {
            let content = that.$refs.ueditor.getUEContent();
            if (
              content == null ||
              content == "" ||
              content == "<p>请输入内容</p>"
            ) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请填写详细描述",
                duration: 2000
              });
              return;
            }
            para.content = content;
            para.type_id = 1;
          } else if (para.info_type == 5) {
            let content = that.$refs.ueditor.getUEContent();
            if (
              content == null ||
              content == "" ||
              content == "<p>请输入内容</p>"
            ) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请填写详细描述",
                duration: 2000
              });
              return;
            }
            para.content = content;
            para.type_id = 1;
          }
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;

          API.add_edit_course(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm1() {
      location.reload();
     //location.replace(location.href);
      // this.$router.go(0);
      // let that = this;
      // that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/add_course.vue